import React, { useState, useEffect, useRef, useCallback } from "react";
import { connect, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import { setUserDetails } from "../redux/actions/userAction";
import HttpService from "../services/httpService";
import moment from "moment";
import { commaSeparateAmount } from "../components/commaSeparate";
import { ROLENAME } from "../utils/index";

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  makeStyles,
  withStyles,
  TextField,
  Button,
  MenuItem,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  FormControl
} from "@material-ui/core";

import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
  },
  root: {
    width: "100%",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  tableViewButton: {
    backgroundColor: "#b7ccf7",
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "30%",
    "&:hover": { backgroundColor: "#14419c", color: "white" },
  },
  leadSearchButton: {
    backgroundColor: "#FDB913",
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
    "&:hover": { backgroundColor: "#14419c", color: "white" },
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ccc",
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const RaiseRefundRequest = (props) => {
  const classes = useStyles();
  const { userDetails } = useSelector((state) => state.user);
  const [qtprojects, setQTProjectRows] = useState([]);
  const [qtBoardViewProjects, setQTBoardViewProject] = useState([]);
  const [dupqtprojects, setDupQtProjects] = useState([]);
  const [searched, setSearched] = useState("");
  const [projectViewType, setProjectViewType] = useState();
  const [totalaPages, setTotalPages] = useState(0);
  const [assignToList, setAssignToList] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [selectedSearchType, setSelectedSearchType] = useState([]);
  const [leadId, setLeadId] = useState("");
  const [sourceOfLeadData, setSourceOfLeadData] = useState([]);
  const [refundRequestView, setRefundRequestView] = useState(false);
  const [refundAmount, setRefundAmount] = useState(0);
  const [totalAmountRefund, setTotalAmountrefund] = useState(0);
  const [refundReqDepartment, setRefundReqDepartment] = useState("");
  const [amountPaid, setAmountPaid] = useState(0);
  const [projectDetails, setProjectDetails] = useState({});
  const [chmRefundRequestDialog, setChmRefundRequestDialog] = useState(false);
  const [departmentStage, setDepartmentsStage] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [raiseUser, setRaiseUser] = useState('')
  const [lostDialog, setLostDialog] = useState(false);
  const [lostRemark, setLostRemark] = useState('');
  const [salesToken, setSalesToken] = useState(0);
  const [chmRefundItems, setChmRefundItems] = useState({
    delayPenality: 0,
    damages: 0,
    goodWillDiscount: 0,
    others: 0,
    referralBonus: 0,
  });

  const [searchTypes, setSearchTypes] = useState([
    { name: "Customer Name" },
    { name: "Email ID" },
    { name: "Lead No" },
    { name: "Project No" },
    { name: "Contact No" },
    { name: "Unique Lead No" },
  ]);

  useEffect(() => {
    getDepartments();
    getUserdata();
    getSourceOfLeadData();
  }, []);

  const getUserdata = async () => {
    const users = await HttpService.getAllMangers();
    setUsersData(users.data);
  };

  const getSourceOfLeadData = async () => {
    const users = await HttpService.getLeadMaster();
    setSourceOfLeadData(users.data);
    props.setSnackInfo("Please search lead to raise refund request","success")
  };

  const getSalesUser = (item) => {
    let salesDataObj = {
      sales_user: "",
      sales_teamId: "",
      sales_manager: "",
    };

    if (item?.assignTo?.roles.find((ele) => ele.name === ROLENAME.SalesUser)) {
      salesDataObj.sales_user = item?.assignTo?.name;
      salesDataObj.sales_teamId = item?.assignTo?.teamId;
    }
    for (let i = 0; i < item?.previouslyAssignedTo?.length; i++) {
      for (let j = 0; j < item?.previouslyAssignedTo[i]?.roles.length; j++) {
        if (
          item.salesLeadOwnRole === "SalesUser" &&
          item?.previouslyAssignedTo[i]?.roles[j].name === ROLENAME.SalesUser
        ) {
          salesDataObj.sales_user = item?.previouslyAssignedTo[i]?.name;
          salesDataObj.sales_teamId = item?.previouslyAssignedTo[i]?.teamId;
        } else if (
          item.salesLeadOwnRole === "SalesManager" &&
          item?.previouslyAssignedTo[i]?.roles[j].name === ROLENAME.SalesManager
        ) {
          salesDataObj.sales_manager = item?.previouslyAssignedTo[i]?.name;
          salesDataObj.sales_user = "NA";
        }
      }
    }

    if (
      item?.assignTo?.roles.find((ele) => ele.name === ROLENAME.SalesManager)
    ) {
      salesDataObj.sales_manager = item?.assignTo?.name;
    }
    return salesDataObj;
  };

  const setHandleSearchedByEnter = (e) => {
    if (e.keyCode === 13) {
      setSearched(searchInput);
      requestSearch(selectedSearchType, searchInput);
    }
  };
  const setHandleSearched = (value) => {
    setSearched(value);
    requestSearch(selectedSearchType, value);
  };

  const requestSearch = async (searchType, search) => {
    try {
      let data = {};
      data.role = "others";
      props.setLoading(true);
      const response = await HttpService.getRefundRequestSearchLeads(
        searchType.name,
        search,
        userDetails.selectedExpCenter,
      );
      props.setLoading(false);
      if (response.data && response.data.totalDocs >= 0) {
          if(response.data.totalDocs === 0){
            let snackString = String(response.data.totalDocs) + " Leads Found!";
            props.setSnackInfo(snackString, "success");
          }
      }
      let i = 1;
      let userTableViewData = [];
      const assignUserList = [];
      response?.data?.docs?.forEach((ele) => {
        ele["projects"]?.forEach((item) => {
          let data = getSalesUser(item);
          item.serial = i++;
          let obj = {
            projectId: item?._id,
            name: item?.customerId?.name,
            lead_no: item?.lead_no,
            customerId: item?.customerId?._id,
            status: item?.status,
            erpProjectNo: item?.erpProjectNo ? item?.erpProjectNo : "-",
            currentStage: item?.currentStage,
            stage: item?.salesStage === "Won" ? item.designStages : item?.salesStage,
            assignTo: item?.assignTo?.name,
            departmentId: item?.departmentId._id,
            department: item?.departmentId?.name,
            totalCustomerOutflow: item?.grandTotal ? item?.grandTotal : `0`,
            reasonForLost:item?.currentStage === "Lost" ? item?.reasonForLost : "-",
            createdAt: moment(item?.createdAt).format("DD-MM-YYYY"),
            lastActivityDate: moment(item?.lastActivityDate).format( "DD-MM-YYYY"),
            uniqueLeadNumber: item?.uniqueLeadNumber,
            expectedSalesclosureDate: item?.expectedSalesclosureDate? moment(item?.expectedSalesclosureDate).format("DD-MM-YYYY"): "NA",
            salesUser: data.sales_user !== "" ? data.sales_user : "NA",
            salesUserTeamId: data.sales_teamId,
            salesManagerName: data.sales_manager,
            expectedHandoverDate: moment(item?.expectedHandoverDate).format( "DD-MM-YYYY"),
            salesStage: item?.salesStage ? item?.salesStage : "-",
            designStages: item?.designStages ? item?.designStages : "-",
            designKickOffCustomerActionFromChm:item?.designKickOffCustomerActionFromChm,
            isRefundRequestSent: item?.isRefundRequestSent ? item?.isRefundRequestSent : "-",
            designLostApproval: item?.designLostApproval,
            salesLostApproval: item?.salesLostApproval,
            salesRefundRequestApproval: item?.salesRefundRequestApproval,
            designRefundRequestApproval: item?.designRefundRequestApproval,
            contractCustomerApproved: item?.contractCustomerApproved,
            contractFinanceApproved: item?.contractFinanceApproved,
            salesToken: item?.salesToken || 0,
            raiseRefundLostSent: item?.raiseRefundLostSent,
            raiseRefundLostUser: item?.raiseRefundLostUser,
            totalAmountRefundedArray: item?.totalAmountRefundedArray
          };
          userTableViewData.push(obj);
          assignUserList.push(item.assignTo?.name);
        });
      });

      const uniqueAssignToList = Array.from(
        new Set(assignUserList.map((a) => a))
      ).map((id) => {
        return assignUserList.find((a) => a === id);
      });
      setAssignToList(uniqueAssignToList);
      setQTProjectRows(userTableViewData);
      setProjectDetails(userTableViewData[0]);
      setDupQtProjects(userTableViewData);
      setQTBoardViewProject(response.data.docs);
      setTotalPages(response.data.totalDocs);
    } catch (error) {
      console.log(error);
    }
  };


  const getDepartments = async () => {
    try {
      const department = await HttpService.getDepartments();
      setDepartmentList(department?.data);
      getDepartmentStages(department?.data);
    } catch (error) {
      console.log(error, "get department error");
    }
  };

  const getDepartmentStages = async (data) => {
    let stages = [];
    if (
      userDetails.roles.find(
        (role) =>
          role.name === ROLENAME.MarketingUser ||
          role.name === ROLENAME.MarketingManager
      )
    ) {
      data.forEach((element) => {
        if (element["name"] === "Sales") {
          stages.push(element["stages"]);
        }
      });
    } else if (
      userDetails.roles.find(
        (role) =>
          role.name === ROLENAME.Admin ||
          role.name === ROLENAME.ProcurementExecutive
      )
    ) {
      return;
    } else {
      data.forEach((element) => {
        if (element["_id"] === userDetails.departmentId) {
          stages.push(element["stages"]);
        }
      });
    }
    setDepartmentsStage(stages?.[0] ? stages?.[0] : "");
  };

  const handle_search_type_selection = (value) => {
    setSelectedSearchType(value);
    setSearchInput("");
  };

  // handle handleRefundRequestButton when click refund request button
  const handleRefundRequestButton = async (stage, row) => {
    props.setLoading(true);
    try {
      if (stage !== "CHM") {
        const designApproval = row?.designLostApproval;
        const salesApproval = row?.salesLostApproval;
        // if lead lost is pending approval
        if (
          designApproval?.odmApproval === "Sent for Approval" ||
          designApproval?.dgmDesignApproval === "Sent for Approval" ||
          designApproval?.adminApproval === "Sent for Approval" ||
          salesApproval?.smApproval === "Sent for Approval" ||
          salesApproval?.dgmSalesApproval === "Sent for Approval" ||
          salesApproval?.centerHeadApproval === "Sent for Approval"
        ) {
          props.setSnackInfo("Please wait until the lost approval done", "warning");
        } else {
          if(row?.salesStage === 'Lost' || row?.designStages === 'Lost'){
          const res = await HttpService.getAmountPaid(row.projectId);
          setAmountPaid(res?.data?.totalPaymentReceived);
          setRefundRequestView(true);
          setLeadId(row.projectId);
          setRefundReqDepartment(stage);
          setRaiseUser(userDetails._id);
          let sumOfRefundedAmount = row?.totalAmountRefundedArray?.reduce((sum,item)=>{
            return sum+ item?.amountRefunded
          },0)
          // setTotalAmountrefund(res.data.totalPaymentReceived);
          setTotalAmountrefund(Number(res.data.totalPaymentReceived) - (Number(sumOfRefundedAmount) || 0));
          } else{
            props.setSnackInfo("Please move lead to lost for raise refund request", "warning");
          }
        }
      } //If stage is chm then come into else part of parent if
      else {
          setRaiseUser(userDetails._id);
          setChmRefundRequestDialog(true);
          setLeadId(row.projectId);
          setRefundReqDepartment(stage);
      }
    } catch (err) {
      props.setSnackInfo("Something went wrong", "error");
    }
    props.setLoading(false);
  };

  // handleEnterRefundAmount function (Enter value for refund and total refund amount calculate)
  const handleEnterRefundAmount = (value) => {
    setRefundAmount(+value);
    let sumOfRefundedAmount = projectDetails?.totalAmountRefundedArray?.reduce((sum,item)=>{
      return sum + item.amountRefunded;
    },0)
    let totalAmount = amountPaid - (Number(value) + (Number(sumOfRefundedAmount) || 0));
    setTotalAmountrefund(totalAmount);
  };

  // handle refund request submit button
  const handleRefundSubmit = async () => {
    props.setLoading(true);
    try {
      if (refundAmount > 0) {
        const obj = {
          amountPaid: amountPaid,
          refundAmount: refundAmount, //Enter refund amount by raising request user
          totalAmountRefund: totalAmountRefund,
          refundReqDepartment: refundReqDepartment,
          refundRaiseUser : raiseUser
        };
        await HttpService.sendApprovalRefundRequest(leadId, obj);
        setRefundRequestView(false);
        setHandleSearched(searchInput.toUpperCase());
        if (
          projectDetails.salesStage !== "Lost" &&
          projectDetails.designStages !== "Lost"
        ) {
          props.setSnackInfo(
            "Refund request sent for approval and lead will be lost once it's approved ",
            "success"
          );
        } else {
          props.setSnackInfo("Refund request sent for approval", "success");
        }
      } else {
        props.setSnackInfo("Please enter refund amount", "warning");
      }
    } catch (err) {
      console.log(err);
      props.setSnackInfo("Something went wrong", "error");
    }
    props.setLoading(false);
  };

  // handle Cancel button when raising refund request
  const handleCancelButton = () => {
    setRefundRequestView(false);
    setRefundAmount(0);
  };

  //   handle handleChmRefundRequest CHM Refund Request approval
  const handleChmRefundRequest = (e) => {
    setChmRefundItems((prev) => ({
      ...prev,
      [e.target.name]: +e.target.value,
    }));
  };

  // handle CHM cancel button for Raise Refund Request
  const handleChmCancelButton = () => {
    setChmRefundRequestDialog(false);
    setChmRefundItems({
      delayPenality: 0,
      damages: 0,
      goodWillDiscount: 0,
      others: 0,
      referralBonus: 0,
    });
  };

  // handle CHM Submit button for Raise Refund Request
  const handleChmRefundSubmit = async () => {
    props.setLoading(true);
    try {
      const sum = Object?.entries(chmRefundItems)?.reduce((acc, [key, value]) => {
        return acc + value;
      }, 0);

      const obj = {
        refundItems: chmRefundItems,
        refundReqDepartment: refundReqDepartment,
        refundRaiseUser : raiseUser,
        refundAmount: sum,
      };
      const res = await HttpService.sendChmRefundApproval(obj, leadId);
      setChmRefundRequestDialog(false);
      setHandleSearched(searchInput.toUpperCase())
      props.setSnackInfo("Refund request sent for approval", "success");
    } catch (err) {
      console.log("error", err);
      props.setSnackInfo("Something went wrong", "error");
    }
    props.setLoading(false);
  };

  const handleMoveToLost = (depatment, row)=>{
    setLostDialog(true);
    setLeadId(row?.projectId);
    setSalesToken(row?.salesToken);
    setRefundReqDepartment(depatment);
  }

  const handleLost = async() => {
    try {
      let obj = {
        remark: lostRemark,
        status: "Lost",
        salesToken: salesToken,
        raiseRefundLostUser: userDetails._id
      }
      let res = await HttpService.moveRefundLeadLost(obj,leadId);
      setLostDialog(false);
      setLostRemark('');
      setHandleSearched(searchInput.toUpperCase());
      props.setSnackInfo("Sent for Lost Approval",'success');
    }
    catch (err) {
      props.setSnackInfo('Something went wrong',"error")
    }
  }

  const handleLostCancel = ()=>{
    setLostDialog(false);
    setLostRemark('');
  }

  return (
    <div>
      <Paper
        style={{ marginTop: "20px", marginBottom: "20px", padding: "20px" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            margin: "Auto",
          }}
        >
          {/* Search Type */}
          <TextField
            select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedSearchType}
            label="Search Type"
            name="searchType"
            onChange={(e) => handle_search_type_selection(e.target.value)}
            variant="outlined"
            style={{ width: "30%", marginRight: "2%" }}
            size="small"
          >
            {searchTypes.map((el) => (
              <MenuItem key={el.name} value={el}>
                {el.name}
              </MenuItem>
            ))}
          </TextField>

          {/* Search Input */}
          <TextField
            label="Enter the input"
            name="searched"
            size="small"
            value={searchInput}
            onKeyDown={setHandleSearchedByEnter}
            onChange={(e) => {
              setSearchInput(e.target.value);
            }}
            variant="outlined"
            style={{ width: "80%" }}
          />

          {/* Search Button */}
          {userDetails?.roles?.find(
            (role) =>
              role.name !== "Procurement Executive" &&
              role.name !== "Store Manager"
          ) && (
            <Button
              disabled={!selectedSearchType.name || !searchInput}
              variant="contained"
              color="primary"
              size="medium"
              style={{ alignSelf: "center", marginLeft: 20 }} // Added height
              className={classes.leadSearchButton}
              onClick={() => setHandleSearched(searchInput.toUpperCase())}
            >
              Search
            </Button>
          )}
        </div>
      </Paper>
      <Paper>
        <TableContainer component={Paper}>
          <Table
            className={classes.table}
            stickyHeader
            aria-label="sticky table"
          >
        {qtprojects.length > 0 && 
           <TableHead>
              <StyledTableRow>
                <StyledTableCell>Sr. No.</StyledTableCell>
                <StyledTableCell>Customer</StyledTableCell>
                <StyledTableCell>Lead No</StyledTableCell>
                <StyledTableCell>Unique Lead No</StyledTableCell>
                <StyledTableCell>Project No.</StyledTableCell>
                <StyledTableCell>Department</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
                <StyledTableCell>Current Stage</StyledTableCell>
                <StyledTableCell>Assigned to</StyledTableCell>
                <StyledTableCell>Quotation Amount</StyledTableCell>
                <StyledTableCell>Action</StyledTableCell>
              </StyledTableRow>
            </TableHead>
          }
            <TableBody>
              {qtprojects
                .sort((a, b) =>
                  b.createdAt
                    .split("-")
                    .reverse()
                    .join()
                    .localeCompare(a.createdAt.split("-").reverse().join())
                )
                .map((row, i) => {
                  return (
                    <StyledTableRow key={i + 1}>
                      <StyledTableCell>{i + 1}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">
                        <Link
                          to={`/project-logs/${row.projectId}`}
                          style={{ color: "#000", textDecoration: "underline" }}
                        >
                          {row?.name}
                        </Link>
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row">{row?.lead_no}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">{row?.uniqueLeadNumber ? row?.uniqueLeadNumber: "NA"}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">{row?.erpProjectNo}</StyledTableCell>
                      <StyledTableCell component="th" scope="row"> {row?.department}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">{row?.status}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">{row?.currentStage}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">{row?.assignTo}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(row?.totalCustomerOutflow)}</StyledTableCell>
                      <StyledTableCell>
                        {userDetails.roles.some(
                          (role) =>
                            [ROLENAME.AssistantSalesManager, ROLENAME.SalesUser, ROLENAME.AssistantDesignManager, ROLENAME.DesignUser].includes(role.name)
                        ) ? (
                          row?.salesStage === "Won" ? (
                            (row?.designStages === "Design Kick-Off : Internal" ||
                              row?.designStages === "Designer Assignment Pending" ||
                              row?.designStages === "Design Kick-Off : Customer") &&
                              (row?.designKickOffCustomerActionFromChm !== "Approved" && userDetails?.departmentId !== row?.departmentId)
                            ? (
                              <>
                              <Button
                                variant="contained"
                                color="primary"
                                style={{ marginTop: 10, float: "right" }}
                                onClick={() => handleRefundRequestButton("Sales", row)}
                                disabled={
                                  row?.isRefundRequestSent === true ||
                                  userDetails?.departmentId === row?.departmentId?._id
                                }
                              >
                                 Raise Refund Request
                              </Button>
                               <Button
                               variant="contained"
                               color="secondary"
                               style={{ marginTop: 10, float: "right" }}
                               onClick={() => handleMoveToLost("Sales", row)}
                               disabled={row?.salesStage === 'Lost' || row?.raiseRefundLostSent}
                           >
                             Move Lead To Lost                           
                           </Button>
                          </>
                            ) : userDetails.roles.some(
                              (role) =>
                                [ROLENAME.AssistantDesignManager, ROLENAME.DesignUser].includes(role.name)
                            ) && row?.designStages === "Lost" && row?.designKickOffCustomerActionFromChm === "Approved" ? (
                              <>
                              <Button
                                variant="contained"
                                color="primary"
                                style={{ marginTop: 10, float: "right" }}
                                onClick={() => handleRefundRequestButton("Design", row)}
                                disabled={row?.isRefundRequestSent === true}
                              >
                                Raise Refund Request
                              </Button>
                               <Button
                               variant="contained"
                               color="secondary"
                               style={{ marginTop: 10, float: "right" }}
                               onClick={() => handleMoveToLost("Sales", row)}
                                disabled={row?.designStages === 'Lost' || row?.raiseRefundLostSent}
                              >
                               Move Lead To Lost                             
                             </Button>
                          </>
                            ) : (
                              "NA"
                            )
                          ) : row?.salesStage === "Won Deals Pending Designer Assignment" &&
                            (row?.designKickOffCustomerActionFromChm === "Rejected" ||  row?.designKickOffCustomerActionFromChm === "Pending") ? (
                              <>
                            <Button
                              variant="contained"
                              color="primary"
                              style={{ marginTop: 10, float: "right" }}
                              onClick={() => handleRefundRequestButton("Sales", row)}
                              disabled={row?.isRefundRequestSent === true}
                            >
                               Raise Refund Request
                            </Button>
                            <Button
                             variant="contained"
                             color="secondary"
                             style={{ marginTop: 10, float: "right" }}
                             onClick={() => handleMoveToLost("Sales", row)}
                             disabled={row?.salesStage === 'Lost' || row?.raiseRefundLostSent}
                           >
                            Move Lead To Lost                              
                           </Button>
                           </>

                          ) : row?.salesStage === "Lost" && ( row?.raiseRefundLostUser && row?.raiseRefundLostSent)? (
                              <>
                              <Button
                                variant="contained"
                                color="primary"
                                style={{ marginTop: 10, float: "right" }}
                                onClick={() => handleRefundRequestButton("Sales", row)}
                                disabled={row?.isRefundRequestSent === true}
                              >
                                Raise Refund Request
                              </Button>
                              <Button
                                variant="contained"
                                color="secondary"
                                style={{ marginTop: 10, float: "right" }}
                                onClick={() => handleMoveToLost("Sales", row)}
                                 disabled={row?.isRefundRequestSent === true || row?.raiseRefundLostSent === true}
                            >
                             Move Lead To Lost                             
                            </Button>
                           </>
                          ) : (
                            "NA"
                          )
                        ) : userDetails.roles.some((role) => role.name === ROLENAME.CHM_User) &&
                          row?.contractCustomerApproved &&
                          row?.contractFinanceApproved &&
                          row?.designStages === "Design Sign-off" ? (
                            <>
                          <Button
                            variant="contained"
                            color="primary"
                            style={{ marginTop: 10, float: "right" }}
                            onClick={() => handleRefundRequestButton("CHM", row)}
                            disabled={row?.isRefundRequestSent === true}
                          >
                            Raise Refund Request
                          </Button>
                      </>
                        ) : (
                          "NA"
                        )}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Refund Request Modal */}
      <Dialog
        open={refundRequestView}
        onClose={() => setRefundRequestView(false)}
      >
        <DialogTitle style={{ margin: "auto" }}> Refund Request </DialogTitle>
        <DialogActions>
          <TableContainer style={{ marginTop: 10 }}>
            <Table size="small">
              <TableBody>
                <TableRow>
                  <TableCell>Amount paid</TableCell>
                  <TableCell>
                    <TextField
                      name="amountPaid"
                      size="small"
                      value={amountPaid}
                      disabled
                      type="number"
                      fullWidth
                      label="Amount received"
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>
               {projectDetails?.totalAmountRefundedArray?.map((item,idx)=>
                <TableRow key={idx}>
                  <TableCell>Amount Refunded</TableCell>
                    <TableCell>
                      <TextField
                        disabled
                        name="totalAmountRefunded"
                        size="small"
                        value={item.amountRefunded}
                        type="number"
                        fullWidth
                        variant="outlined"
                      />
                    </TableCell>
                  </TableRow>
               )}
                <TableRow>
                  <TableCell>Amount to be refunded</TableCell>
                  <TableCell>
                    <TextField
                      name="amountToBeRefund"
                      size="small"
                      value={refundAmount}
                      onChange={(e) => handleEnterRefundAmount(e.target.value)}
                      type="number"
                      label="Amount to be refunded"
                      fullWidth
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Balance Amount</TableCell>
                  <TableCell>
                    <TextField
                      name="totalAmountRefund"
                      size="small"
                      value={totalAmountRefund}
                      type="number"
                      label="Balance Amount"
                      fullWidth
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <div style={{ margin: "10px", float: "right" }}>
              <Button
                onClick={handleRefundSubmit}
                style={{ marginRight: "3px" }}
                color="primary"
                variant="contained"
              >
                Submit
              </Button>
              <Button
                onClick={handleCancelButton}
                color="secondary"
                variant="contained"
              >
                Cancel
              </Button>
            </div>
          </TableContainer>
        </DialogActions>
      </Dialog>

      {/* CHM_User refund request modal */}
      <Dialog
        open={chmRefundRequestDialog}
        onClose={() => setChmRefundRequestDialog(false)}
      >
        <DialogTitle style={{ margin: "auto" }}> CHM User Refund Request </DialogTitle>
        <DialogActions>
          <TableContainer style={{ marginTop: 10 }}>
            <Table size="small">
              <TableBody>
              {projectDetails?.totalAmountRefundedArray?.map((item,idx)=>
                <TableRow key={idx}>
                  <TableCell>Amount Refunded</TableCell>
                    <TableCell>
                      <TextField
                        name="totalAmountRefunded"
                        size="small"
                        value={item.amountRefunded}
                        type="number"
                        fullWidth
                        disabled
                        variant="outlined"
                      />
                    </TableCell>
                  </TableRow>
               )}
                <TableRow>
                  <TableCell>Delay Penality</TableCell>
                  <TableCell>
                    <TextField
                      name="delayPenality"
                      size="small"
                      value={chmRefundItems.delayPenality}
                      onChange={(e) => handleChmRefundRequest(e)}
                      type="number"
                      label="Delay Penality"
                      fullWidth
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>Damages</TableCell>
                  <TableCell>
                    <TextField
                      name="damages"
                      size="small"
                      value={chmRefundItems.damages}
                      onChange={(e) => handleChmRefundRequest(e)}
                      type="number"
                      label="Damages"
                      fullWidth
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>Good Will Discount</TableCell>
                  <TableCell>
                    <TextField
                      name="goodWillDiscount"
                      size="small"
                      value={chmRefundItems.goodWillDiscount}
                      onChange={(e) => handleChmRefundRequest(e)}
                      type="number"
                      label="Good Will Discount"
                      fullWidth
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>Others</TableCell>
                  <TableCell>
                    <TextField
                      name="others"
                      size="small"
                      value={chmRefundItems.others}
                      onChange={(e) => handleChmRefundRequest(e)}
                      type="number"
                      label="Others"
                      fullWidth
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>Referral Bonus</TableCell>
                  <TableCell>
                    <TextField
                      name="referralBonus"
                      size="small"
                      value={chmRefundItems.referralBonus}
                      onChange={(e) => handleChmRefundRequest(e)}
                      type="number"
                      label="Referral Bonus"
                      fullWidth
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <div style={{ margin: "10px", float: "right" }}>
              <Button
                onClick={handleChmRefundSubmit}
                style={{ marginRight: "3px" }}
                color="primary"
                variant="contained"
              >
                Submit
              </Button>
              <Button
                onClick={handleChmCancelButton}
                color="secondary"
                variant="contained"
              >
                Cancel
              </Button>
            </div>
          </TableContainer>
        </DialogActions>
      </Dialog>

      {/* Move to lost lead in refund request */}
      <Dialog
        open={lostDialog}
        onClose={() => setLostDialog(false)}
      >
        <DialogTitle style={{ margin: "auto" }}> Confirm moving the lead to lost </DialogTitle>
        <DialogContent>
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <FormControl fullWidth style={{ paddingTop: 20,}} variant="outlined" size="small">
              <TextField
                id="design-hold-reason"
                label="Lost Remarks"
                name="resonDesignHold"
                required="true"
                value={lostRemark}
                onChange={(e) => setLostRemark(e.target.value)}
                variant="outlined"
                size="small"
              />
            </FormControl>
            </div>
        </DialogContent>
        <DialogActions>
            <div style={{ margin: "10px", display:'flex' }}>
              <Button
                onClick={handleLost}
                style={{ marginRight: "3px" }}
                color="primary"
                variant="contained"
                disabled = {lostRemark === ''}
              >
                Submit
              </Button>
              <Button
                onClick={handleLostCancel}
                color="secondary"
                variant="contained"
              >
                Cancel
              </Button>
            </div>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default connect(null, { setUserDetails, setLoading, setSnackInfo })(
  RaiseRefundRequest
);